import { makeStyles } from 'tss-react/mui'

export const getOrMakeSimpleAlertMessageContentStyles = makeStyles()(() => ({
    content: {
        minHeight: 64
    }
}))
